export enum ActionTypes {
  SET = "@tree-view/SET",
}
